<template>
  <page>
    <v-container fluid grid-list-lg>
      <v-layout row wrap>
        <v-flex xs12>
          <v-toolbar dense color="grey lighten-3" flat>
            <v-btn text icon color="green">
              <v-icon @click.native="doExit">mdi-keyboard-backspace</v-icon>
            </v-btn>
            <v-icon>mdi-magnify</v-icon>
            <v-toolbar-title>View Policy Transaction</v-toolbar-title>
            <v-spacer></v-spacer>
            <ButtonPrintSchedule
              v-if="showButton"
              labelName="Print Schedule"
              :polNo="polMaster.polNo"
              :renCnt="polMaster.renCnt"
              :endtCnt="polMaster.endtCnt"
              :tranRel="polMaster.tranRel"
              :schedForm="polMaster.schedForm"
            ></ButtonPrintSchedule>
          </v-toolbar>
          <QueryPolicyBody></QueryPolicyBody>
        </v-flex>
        <v-dialog v-model="loadingFlag" persistent width="300">
          <v-card color="primary" dark>
            <v-card-text>
              Loading...
              <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-layout>
    </v-container>
  </page>
</template>

<script>
import QueryPolicyBody from './QueryPolicyBody'
import ButtonPrintSchedule from '@/components/core/common/button/ButtonPrintSchedule.vue'
import { dispatchMixin } from '@/mixins/common/dispatchMixin'
import MessageMixin from '@/mixins/message'

export default {
  data() {
    return {
      loadingFlag: false,
      showButton: true
    }
  },
  created() {
    this.initCommonUtilMenu()
    this.setCommonDispatch()
  },
  beforeMount() {
    this.initReport()
  },
  methods: {
    async doExit() {
      this.loadingFlag = true
      this.redirect()
    },
    async redirect() {
      await this.dispatch('policyListing')
    },
    setCommonDispatch() {
      if (this.commonDispatch.key === 'ReviewClaim' || this.commonDispatch.key === 'QueryClaim') {
        this.showButton = false
      } else {
        this.showButton = true
      }
    },
    async initReport() {
      if (this.$store.state.reports.init !== 1) {
        await this.$store.dispatch('reportsInit')
      }
    }
  },
  computed: {
    polMaster() {
      return this.$store.state.underwriting.policy.polMaster
    },
    commonDispatch() {
      return this.$store.state.commons.dispatch
    }
  },
  watch: {
    commonDispatch: function (value) {
      this.setCommonDispatch()
    }
  },
  mixins: [dispatchMixin, MessageMixin],
  components: {
    QueryPolicyBody,
    ButtonPrintSchedule
  }
}
</script>

<style>
</style>
